import React, {useCallback, useEffect, useState} from 'react'
import { Grid, Button } from '@mui/material'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { useSelector } from 'react-redux'
import { RootStore, useAppDispatch } from '../../../redux/store'
import AutocompleteList from '../../../shared/UI/AutocompleteList'
import ButtonSmall from '../../../shared/UI/ButtonSmall'
import { resetFilters, setSelectedEmployees as setSelectedEmployeesAction } from "../../../redux/reducers/enhancementsSummaryReducer"
import {Employee} from "../../../services/dashboardService"
import actionsService from '../../../services/actionsService'

function EnhancementsFilterPanel({ handleClose}: { handleClose: () => void }) {
  const dispatch = useAppDispatch()
  const allEmployees = useSelector((state: RootStore) => state.appSettings.directReports)

  const selectedEmployeeIds = useSelector((state: RootStore) => state.enhancementsSummary.filterStates.selectedEmployeeIds)
  const [selectedEmployees, setSelectedEmployees] = useState<Employee[]>(() =>
      allEmployees.filter(emp => selectedEmployeeIds.includes(emp.employeeId))
  )
  
  const resetToDefaultSettings = useCallback(() => {
    actionsService.userAnalytics
      .postEvent('UIClickEvent', 'EnhancementsFiltersResetAllClick', window.location.pathname, window.location.hostname)
      .catch((error: unknown) => console.error('Analytics tracking error:', error))
    dispatch(resetFilters())
    handleClose()
  }, [dispatch, handleClose])

  const submitFilterParams = useCallback(() => {
    actionsService.userAnalytics
      .postEvent('UIClickEvent', 'EnhancementsFiltersApplyClick', window.location.pathname, window.location.hostname)
      .catch((error: unknown) => console.error('Analytics tracking error:', error))
    const employeeIds = selectedEmployees.map(emp => emp.employeeId)
    dispatch(setSelectedEmployeesAction(employeeIds))
    handleClose()
  }, [dispatch, selectedEmployees, handleClose])


  return (
    <Grid container data-testid="filter-panel" sx={{ backgroundColor: '#fff', display: 'flex', flexDirection: 'column',  padding: '24px' }}>
      <Grid marginBottom="16px">
        <AutocompleteList
          multiple
          id="employee"
          label="Employee"
          data={allEmployees}
          textField="employeeName"
          value={selectedEmployees}
          onChange={(_e, employees: Employee[]) => {
            actionsService.userAnalytics
              .postEvent('UIClickEvent', 'EnhancementsFiltersEmployeeDropdownChange', window.location.pathname, window.location.hostname)
              .catch((error: unknown) => console.error('Analytics tracking error:', error))
            setSelectedEmployees(employees)
          }}
          dataTestId="enhancements-employee-dropdown"
          limitTags={1}
        />
      </Grid>
      <Grid display="flex" alignItems="center" justifyContent="flex-end">
        <Button
          size="small"
          onClick={resetToDefaultSettings}
          startIcon={<RestartAltIcon />}
          sx={{ mr: 4 }}
        >
          Reset all
        </Button>
        <ButtonSmall
          label="Apply"
          sx={{ minWidth: '90px', fontSize: '11px', margin:'-13px 0'}}
          onClick={submitFilterParams}
        />
      </Grid>
    </Grid>
  )
}

export default EnhancementsFilterPanel